import React from 'react';
import { values } from 'lodash';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import * as analytics from '@eb/site-analytics';

import { getCanonicalSearchUrl } from '@eb/redux-destination';

import { trackEventClickInternal as trackEventClickInternalAction } from '../../../../redux/actions/analytics';
import { searchByBBoxOrPlace as searchByBBoxOrPlaceAction } from '../../../../redux/actions/search';
import { saveEvent as saveEventAction } from '../../../../redux/actions/event';

import {
    eventsCardInfoLookup,
    getSearchContent,
    getSearchSection,
} from '../../../../utils/general';
import { hasEventResults } from '../../utils/events';
import { addSearchIdToGaAction } from '../../utils/analytics';
import PropTypes from 'prop-types';

import { MapContainer } from '../MapContainer';

const { trackEventFromState } = analytics;

export const SearchMapSection = ({
    classes,
    hoverEventCardTarget,
    onSaveEvent,
    isMobile,
    isFixed,
    setShouldScroll,
    location,
    history,
}) => {
    let component = null;

    if (!location.isOnline) {
        component = (
            <MapContainer
                hoverEventCardTarget={hoverEventCardTarget}
                onSaveEvent={onSaveEvent}
                isMobile={isMobile}
                isFixed={isFixed}
                setShouldScroll={setShouldScroll}
                history={history}
            />
        );

        if (classes) {
            component = <div className={classes}>{component}</div>;
        }
    }

    return component;
};

export class MapPanel extends React.PureComponent {
    static propTypes = {
        onSaveEvent: PropTypes.func,
    };

    render() {
        const {
            onSaveEvent,
            location,
            hoverEventCardTarget,
            shouldLoadGoogleMap,
        } = this.props;

        if (!shouldLoadGoogleMap) {
            return null;
        }

        const searchMapProps = {
            hoverEventCardTarget,
            onSaveEvent,
            location,
        };

        return (
            <SearchMapSection
                {...searchMapProps}
                history={this.props.history}
            />
        );
    }
}

const _getEventSuggestions = (rawEvents, currencyFormat, section) => {
    const events = values(rawEvents);

    return eventsCardInfoLookup({
        bucketsContent: events,
        currencyFormat,
        section,
    });
};

export const _mapStateToProps = (state) => {
    const section = getSearchSection(state.location.isOnline);
    const results = getSearchContent(
        state.content.entities,
        state.pagination,
        state.currencyFormat,
        section,
    );

    return {
        results,
        shouldLoadGoogleMap: state.ui.isGoogleMapLoaded,
        hasEventResults: hasEventResults(results),
        isAuthenticated: state.auth.isAuthenticated,
        shareOptions: state.share.options,
        isLoading: state.pagination.loading,
        eventSuggestions: _getEventSuggestions(
            state.suggestions.rawEvents,
            state.currencyFormat,
            section,
        ),
        hoverEventCardTarget: state.ui.eventHoverTarget,
        allEventsUrl: getCanonicalSearchUrl({ slug: state.location.slug }),
        featureFlags: state.app.featureFlags,
        location: state.location,
        domain: state.app.domain,
        trackGAEvent: (action) =>
            trackEventFromState(state, addSearchIdToGaAction(action, state)),
    };
};

const _mapDispatchToProps = (dispatch, ownProps) => ({
    handleLocationSelect: (...args) =>
        dispatch(searchByBBoxOrPlaceAction(ownProps.history, ...args)),
    onSaveEvent: (...args) => dispatch(saveEventAction(...args, true)),
    onTrackEventClickInternal: (...args) =>
        dispatch(trackEventClickInternalAction(...args)),
});

export const MapPanelContainer = withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(MapPanel),
);
